import React, { useCallback, useEffect, useState } from "react";
import { Form, Row, Col, Space, Button, Spin } from "antd";
import { InputFields } from "components/common";
import { dataFields } from "./config";
import { Editor } from "react-draft-wysiwyg";

import {
  EditorState,
  ContentState,
  convertFromRaw,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import electrocardiographyService from "api/electrocardiography";
import { SaveWhiteIconSVG } from "assets";
import draftToHtml from "draftjs-to-html";
import Notification from "components/common/notification/notification";
import { fontOptions } from "pages/Electrocardiography/tabs/DetailDiagnose/ElectrocardiographyInfo/TextEditor";

const ModalContent = (props) => {
  const { data, closeModal, type, getListElectro } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [editorState, setEditorState] = useState(null);
  const onEditorStateChange = useCallback((editorState) => {
    setEditorState(editorState);
  }, []);

  useEffect(() => {
    if (data?.moTa) {
      const blockFromHTMl = convertFromHTML(data?.moTa);
      const state = ContentState.createFromBlockArray(
        blockFromHTMl.contentBlocks,
        blockFromHTMl.entityMap
      );
      setEditorState(EditorState.createWithContent(state));
    } else setEditorState(null);

    form.setFieldsValue({
      ...data,
    });
  }, [data]);

  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);

  const addDilate = async () => {
    setLoading(true);
    try {
      const params = form.getFieldsValue();

      const formatValues = {
        ...params,
        moTa: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      };
      const res =
        await electrocardiographyService.postLisElectoCardiographyCatalog(
          formatValues
        );
      setLoading(false);
      closeModal();

      getListElectro();

      Notification("success", "Thêm mới mẫu điện tim thành công");
    } catch (error) {
      setLoading(false);

      Notification("error", "Thêm mới mẫu điện không thành công");
    }
  };
  const editDilate = async () => {
    setLoading(true);
    try {
      const params = form.getFieldsValue();
      const formatValues = {
        ...params,
        moTa: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      };

      const res =
        await electrocardiographyService.updateLisElectoCardiographyCatalog(
          formatValues
        );

      form.setFieldsValue(res);
      setLoading(false);
      getListElectro();
      Notification("success", "Cập nhật mẫu điện tim thành công");

      closeModal();
    } catch (error) {
      setLoading(false);
      Notification("error", "Cập nhật mẫu điện không thành công");
    }
  };
  const onFinish = (values) => {
    if (type == "Thêm") {
      addDilate();
    } else {
      editDilate();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col xl={24} className="editor">
                <Form.Item
                  labelAlign="left"
                  label="Mô tả"
                  name={"moTa"}
                  labelCol={{ xl: 3 }}
                  wrapperCol={{ xl: 21 }}
                >
                  <Editor
                    editorState={editorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={onEditorStateChange}
                    toolbar={fontOptions}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify={"end"} gutter={[16, 0]}>
              <Col>
                <Button danger type="primary" onClick={closeModal}>
                  Hủy bỏ
                </Button>
              </Col>
              <Col>
                <Button
                  className="custom-btn"
                  icon={<SaveWhiteIconSVG />}
                  type="primary"
                  htmlType="submit"
                >
                  Lưu lại
                </Button>
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default ModalContent;
